import { TFunction } from 'react-i18next'
import * as yup from 'yup'
import { createIbanSchema } from 'utils/yupSchemas/accountNumbersSchemas'

export const getEurSpecificSchemaFields = (t: TFunction<'translation', undefined>) => {
  const bicMinLength = 8
  const bicMaxLength = 11

  const iban = createIbanSchema(t)

  const bicLabel = t('bic')
  const bic = yup
    .string()
    .trim()
    .label(bicLabel)
    .min(
      bicMinLength,
      t('fieldMinLength', {
        field: bicLabel,
        min: bicMinLength,
      })
    )
    .max(
      bicMaxLength,
      t('fieldMaxLength', {
        field: bicLabel,
        max: bicMaxLength,
      })
    )
    .matches(
      /^[0-9a-zA-Z]+$/,
      t('fieldAlphanumeric', {
        field: bicLabel,
      })
    )

  return {
    iban,
    bic,
  }
}
